import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { countriesListRoutes } from './allRoutes';
const switchRoutes = (
  <Switch>
    {countriesListRoutes.map((prop, key) => {
      if (prop.layout === 'country') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/country" to="/country/listing" />
  </Switch>
);

const Countries = () => {
  const { user } = useUserAuth();
  return <> {user && switchRoutes} </>;
};

export default Countries;
